import React from "react";
import { formatMessage } from "lib/globalize-util";
import { Chip } from "@material-ui/core";
import { customOptionStyles } from "./styles";
import { IDropdownOption } from "@nuorder/components";

interface IProps {
    option: IDropdownOption;
    collectionName?: string;
    isServerRollup: boolean;
    isUserDefined: boolean;
}

export const CustomUserDefinedAttributeOption: React.FC<IProps> = ({
    option,
    collectionName,
    isServerRollup,
    isUserDefined,
}) => {
    const styles = customOptionStyles();
    return (
        <div {...styles}>
            <div className="attribute">
                <span className="attributeName">{option.text}</span>{" "}
                <Chip label={formatMessage("User")} className="attributeUserDefined" />
            </div>
            {isServerRollup && (
                <div className="assortmentName" title={collectionName}>
                    {collectionName}
                </div>
            )}
        </div>
    );
};
